import { Injectable } from '@angular/core';
import { CommunicationService } from 'src/app/services/communication.service';
import { DrrCcdDeviceApplicationDto } from './technical-data.domain';
import { Observable } from 'rxjs';
import { apiUrls } from '../drr-ccd-devices.constants';
import { GridApplicationService } from 'src/app/+grid-application-shared/services/grid-application.service';
import { AddressAndPersonalData } from 'src/app/+grid-application-shared/entities/personal-data/addressAndPersonalData';
import { map } from 'rxjs/operators';
import { parseBoolelanOrNull } from 'src/app/+shared/helpers/parsers.helper';

@Injectable({
  providedIn: 'root',
})
export class DrrCcdDeviceService extends GridApplicationService<DrrCcdDeviceApplicationDto> {
  private readonly operatorAddressUrl: string = apiUrls.drrCcdCreatePowerPlantOperatorAddress;

  constructor(communicationService: CommunicationService) {
    super(communicationService, {
      technicalData: apiUrls.drrCcdDeviceApplicationUrl,
      uploadDocument: apiUrls.drrCcdUploadDocumentsUrl,
    });
  }

  getCcdDeviceApplication(applicationId: number | string): Observable<DrrCcdDeviceApplicationDto> {
    const url = apiUrls.drrCcdDeviceApplicationUrl + `?application_id=${applicationId}`;

    return this.communicationService.getData<DrrCcdDeviceApplicationDto>(url).pipe(
      map((application: DrrCcdDeviceApplicationDto) => {
        application.is_commissioning_done = parseBoolelanOrNull(application.is_commissioning_done);
        application.is_commissioning_confirmed = parseBoolelanOrNull(application.is_commissioning_confirmed);
        return application;
      })
    );
  }

  fetchApplication(applicationId: number | string): Observable<DrrCcdDeviceApplicationDto> {
    return this.getCcdDeviceApplication(applicationId);
  }

  createDrrCcdDeviceApplication(request: DrrCcdDeviceApplicationDto): Observable<number> {
    return this.communicationService.postData<number>(apiUrls.drrCcdDeviceApplicationUrl, request);
  }

  updateDrrCcdDeviceApplication(request: DrrCcdDeviceApplicationDto): Observable<number> {
    const applicationId = request.application_id;
    request.application_id = undefined; // remove the application_id because it's not allowed in the request body
    return this.communicationService.updateData<number>(apiUrls.drrCcdDeviceApplicationUrl + `?application_id=${applicationId}`, request);
  }

  public createPpOperatorAddress(address: AddressAndPersonalData): Observable<any> {
    return this.communicationService.postData(this.operatorAddressUrl, address);
  }

  public updatePpOperatorAddress(address: AddressAndPersonalData): Observable<any> {
    return this.communicationService.updateData(this.operatorAddressUrl, address);
  }

  public deletePpOperatorAddress(operatorAddressId: number): Observable<any> {
    return this.communicationService.deleteData(`${this.operatorAddressUrl}?id=${operatorAddressId}`);
  }
}
